import {
  articleFiveText,
  articleFourText,
  articleOneText,
  articleSevenText,
  articleSixText,
  articleThreeText,
  articleTwoText,
  cguTitles,
  definitionText,
  firstULText,
  secondULText,
  thirdULText
} from './text-CGU';

const {
  title,
  subtitleOne,
  articleOne,
  articleTwo,
  articleThree,
  articleFour,
  articleFive,
  articleSix,
  articleSeven
} = cguTitles;

const BLOCKS = [
  { title: subtitleOne, paragraphs: definitionText, list: firstULText },
  { title: articleOne, paragraphs: articleOneText },
  { title: articleTwo, paragraphs: articleTwoText },
  { title: articleThree, paragraphs: articleThreeText },
  { title: articleFour, paragraphs: articleFourText, list: secondULText },
  { title: articleFive, paragraphs: articleFiveText },
  { title: articleSix, paragraphs: articleSixText, list: thirdULText },
  { title: articleSeven, paragraphs: articleSevenText }
];

// Rendu sous les mentions légales, d'où le titre de second rang et les articles
// en h3 : la page n'a qu'un seul h1, celui de son en-tête.
const CGU = () => {
  return (
    <>
      <h2 className="legal-section-title">{title}</h2>

      {BLOCKS.map(({ title, paragraphs, list }) => (
        <section className="legal-block" key={title}>
          <h3 className="legal-block-title">{title}</h3>

          {paragraphs.map((paragraph) => (
            <p key={paragraph.text}>{paragraph.text}</p>
          ))}

          {list && (
            <ul>
              {list.map((item) => (
                <li key={item.text}>{item.text}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <p className="legal-date">Tous droits réservés - 4 juillet 2022</p>
    </>
  );
};

export default CGU;
